require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-zeeuws-ruimtelijk-decreet.json") })
        }
      }, "path---projecten-zeeuws-ruimtelijk-decreet");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-zeeuws-ruimtelijk-decreet!./.cache/json/projecten-zeeuws-ruimtelijk-decreet.json
// module id = 458
// module chunks = 231608221292675